import { Button } from "@msuite/ui/button";
import { Icon, icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Menu } from "@msuite/ui/menu";
import { useAuth } from "@/hooks/use-auth";
import { useCitadel } from "@/hooks/use-citadel";
import { useDailyContext } from "../daily/context";
import { useCrewContext } from "./context";

/** Props Interface */
interface CrewMenuProps {
	onDelete: () => void;
}

export function CrewMenu({ onDelete }: CrewMenuProps) {
	/** Context */
	const { crew } = useCrewContext();
	const { t } = useTranslation();
	const { organization } = useAuth();
	const { isInteractionBlocked } = useDailyContext();
	const { citadel } = useCitadel();

	/** Functions */
	function handleOnNavigateToOrganization() {
		window.open(`/partners/${crew.orgId}`);
	}

	/** Computed */
	// The entry leads to /partners/:orgId, which reads the partnership's commercial half. It is
	// offered exactly when the crew belongs to somebody else, so without `read Partner` it is a
	// dead link — hidden rather than disabled, since the crew's own name already says whose it is.
	const informationIsDenied = !!citadel && citadel.cannot("read", "Partner");

	/** Render */
	return (
		<Menu
			items={() => [
				informationIsDenied
					? null
					: {
							label: t("general.information"),
							onClick: handleOnNavigateToOrganization,
							icon: icon("Info"),
							isDisabled: crew.orgId === organization?.id,
						},
				"divider",
				{
					label: t("general.delete"),
					onClick: onDelete,
					icon: icon("Trash2"),
					isDanger: true,
					isDisabled: isInteractionBlocked,
				},
			]}
		>
			<Button
				variant="ghost"
				size="xxs"
				icon={<Icon name="EllipsisVertical" />}
			/>
		</Menu>
	);
}
